export default "__VITE_ASSET__CvSp55rl__"